import { getVoiceAssessmentSessionDefinitionId } from '@/src/config/voice-assessment-session'
import { useSuspenseQuery } from '@tanstack/react-query'

import { appQueryOptions } from '../queries/view-queries'
import { useContentfulLocale } from './useContentfulLocale'
import { useRequiredAppSessionUser } from './useRequiredAppSessionUser'

export function useAppSessionDefinitionId(): number {
  const contentfulLanguage = useContentfulLocale()
  const { backendUser } = useRequiredAppSessionUser()
  const { data } = useSuspenseQuery({
    ...appQueryOptions(contentfulLanguage),
    select: (data) =>
      getVoiceAssessmentSessionDefinitionId({
        app: data,
        user: backendUser,
      }),
  })

  return data
}
